"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VehicleIcon;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Icon = require("./Icon");

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VehicleIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement("path", { d: "M18 7C18.3913 7 18.7427 7.22763 18.9056 7.57581L18.9487 7.68377L19.9487 10.6838C19.9713 10.7517 19.9866 10.8219 19.9942 10.8929L20 11V15C20 16.6569 18.6569 18 17 18C15.6941 18 14.5831 17.1656 14.171 16.0009H11.829C11.4169 17.1656 10.3059 18 9 18C7.69412 18 6.58311 17.1656 6.17102 16.0009L5 16C4.48716 16 4.06449 15.614 4.00673 15.1166L4 15V13C4 11.4023 5.24892 10.0963 6.82373 10.0051L7 10H7.584L10.2929 7.29289C10.4492 7.13661 10.6519 7.0374 10.8686 7.00867L11 7H18ZM9.017 14L8.98284 14.0001C8.43847 14.0093 8 14.4534 8 15C8 15.5523 8.44772 16 9 16C9.55228 16 10 15.5523 10 15C10 14.4477 9.55228 14 9 14H9.017ZM17.017 14L16.9828 14.0001C16.4385 14.0093 16 14.4534 16 15C16 15.5523 16.4477 16 17 16C17.5523 16 18 15.5523 18 15C18 14.4477 17.5523 14 17 14H17.017Z" })
  );
}